@defer (on viewport) {
	<img id="footer-logo" src="./assets/images/logo-blk-001.svg" width="60" @deferState />
	<div id="footer-contact" @deferState>
		<a href="mailto:create@nhdsgn.com">create&#64;nhdsgn.com</a><br />
		646.348.4526
	</div>
} @placeholder {
	<div class="defer-ph"></div>
}
